import { render, staticRenderFns } from "./ManagerSupport.vue?vue&type=template&id=4bd5b4ce"
import script from "./ManagerSupport.vue?vue&type=script&lang=js"
export * from "./ManagerSupport.vue?vue&type=script&lang=js"
import style0 from "./ManagerSupport.vue?vue&type=style&index=0&id=4bd5b4ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports